import { campaignTemplateQueries } from "./campaignTemplateApis";
import { candidateMutations, candidateQueries } from "./candidateApis";
import { domoMutations, domoQueries } from "./domoApis";
import { JourneyTemplateMutations, JourneyTemplateQueries } from "./journeyTemplateApis";
import { touchpointInstancesQueries } from "./touchpointInstancesApis";
import { companyQueries, companyMutations } from "./companyApis";
import { designationQueries } from "./designationApis";
import { employeeMutations, employeeQueries } from "./employeeApis";
import { positionMutations, positionQueries } from "./positionsApis";
import { userMutations, userQueries } from "./userApis";
import {
  hiringManagerPortalMutations,
  hiringManagerPortalQueries,
} from "./hiringManagerPortalApis";
import { roleQueries } from "./roleApis";
import { newsFeedQueries } from "./newsFeedApis";
import { linkedInQueries } from "./linkedInApis";
import { timeSlotMutations, timeSlotQueries } from "./timeSlotApis";
import { engagementMetricMutations } from "./engagementMetricApis";
import { touchpointInstancesMutations } from "./touchpointInstancesApis";
import { meetingLocationQueries, meetingLocationMutations } from "./meetingLocationApis";
import { filterQueries } from "./filterApis";

export const mutations = {
  ...domoMutations,
  ...JourneyTemplateMutations,
  ...companyMutations,
  ...userMutations,
  ...candidateMutations,
  ...positionMutations,
  ...employeeMutations,
  ...timeSlotMutations,
  ...engagementMetricMutations,
  ...touchpointInstancesMutations,
  ...meetingLocationMutations,
  ...hiringManagerPortalMutations,
};

export const queries = {
  ...domoQueries,
  ...JourneyTemplateQueries,
  ...positionQueries,
  ...companyQueries,
  ...userQueries,
  ...hiringManagerPortalQueries,
  ...designationQueries,
  ...employeeQueries,
  ...candidateQueries,
  ...campaignTemplateQueries,
  ...touchpointInstancesQueries,
  ...roleQueries,
  ...newsFeedQueries,
  ...linkedInQueries,
  ...timeSlotQueries,
  ...meetingLocationQueries,
  ...filterQueries,
};
